import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, EllipsisHorizontalIcon } from '@heroicons/react/20/solid'
import { useEffect, useRef } from 'react'


export function Calender({ ...props }) {
    const [current, setCurrent] = useState(new Date());
    let currentDate = new Date();
    if(props.defaultValue) {
        currentDate = props.defaultValue;
    }
    const [month, setMonth] = useState((currentDate.getMonth()));
    const [selectedDate, setSelectedDate] = useState(current);
    
    currentDate.setMonth( month );
    
    currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    var firstOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var lastOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth()+1, 1);

    let firstDayOfMonth = firstOfMonth.getDay();
    let startCalender = new Date( currentDate.getFullYear(), currentDate.getMonth(), 1 );

    var day = startCalender.getDate() - (startCalender.getDay());
    if(day > 0) {
        day -= 7;     
    }
    startCalender.setDate(day);
//startCalender.setDate(1);
const monthNames = {
    1: "Januari",
    2: "Februari",
    3: "Maart",
    4: "April",
    5: "Mei",
    6: "Juni",
    7: "Juli",
    8: "Augustus",
    9: "September",
    10: "Oktober",
    11: "November",
    12: "December",
}

  useEffect(() => {
      if(props.defaultValue) {
          setSelectedDate(props.defaultValue);
            setCurrent(props.defaultValue);          
       }
    return () => {

    };
  }, [props.defaultValue]);
const days = [


  { date: '2021-12-27' },
  { date: '2021-12-28' },
  { date: '2021-12-29' },
  { date: '2021-12-30' },
  { date: '2021-12-31' },
  { date: '2022-01-01', isCurrentMonth: true },
  { date: '2022-01-02', isCurrentMonth: true },
  { date: '2022-01-03', isCurrentMonth: true },
  { date: '2022-01-04', isCurrentMonth: true },
  { date: '2022-01-05', isCurrentMonth: true },
  { date: '2022-01-06', isCurrentMonth: true },
  { date: '2022-01-07', isCurrentMonth: true },
  { date: '2022-01-08', isCurrentMonth: true },
  { date: '2022-01-09', isCurrentMonth: true },
  { date: '2022-01-10', isCurrentMonth: true },
  { date: '2022-01-11', isCurrentMonth: true },
  { date: '2022-01-12', isCurrentMonth: true },
  { date: '2022-01-13', isCurrentMonth: true },
  { date: '2022-01-14', isCurrentMonth: true },
  { date: '2022-01-15', isCurrentMonth: true },
  { date: '2022-01-16', isCurrentMonth: true },
  { date: '2022-01-17', isCurrentMonth: true },
  { date: '2022-01-18', isCurrentMonth: true },
  { date: '2022-01-19', isCurrentMonth: true },
  { date: '2022-01-20', isCurrentMonth: true, isToday: true },
  { date: '2022-01-21', isCurrentMonth: true },
  { date: '2022-01-22', isCurrentMonth: true, isSelected: true },
  { date: '2022-01-23', isCurrentMonth: true },
  { date: '2022-01-24', isCurrentMonth: true },
  { date: '2022-01-25', isCurrentMonth: true },
  { date: '2022-01-26', isCurrentMonth: true },
  { date: '2022-01-27', isCurrentMonth: true },
  { date: '2022-01-28', isCurrentMonth: true },
  { date: '2022-01-29', isCurrentMonth: true },
  { date: '2022-01-30', isCurrentMonth: true },
  { date: '2022-01-31', isCurrentMonth: true },
  { date: '2022-02-01' },
  { date: '2022-02-02' },
  { date: '2022-02-03' },
  { date: '2022-02-04' },
  { date: '2022-02-05' },
  { date: '2022-02-06' },
];
const setSelected =(date)=> {
    if(props.changeEvent) {
        let name = (props.name) ? props.name : "calender";
        props.changeEvent(name, date);
    }
    
    setSelectedDate(date);
    }
const buildCalender =(startCalender, currentDate)=> {
    let calenderRows = [];
    let day = null;
    for(let i=0; i < 42; i++) {
         day = startCalender.getDate() + 1;
         startCalender.setDate(day);
            let dayIdx = startCalender.getDay();
            let isCurrentMonth = (startCalender.getMonth() == currentDate.getMonth());
            let isToday = (startCalender.getFullYear() == current.getFullYear()) && (startCalender.getMonth() == current.getMonth()) && (startCalender.getDate() == current.getDate());
            let isSelected = selectedDate && ((startCalender.getFullYear() == selectedDate.getFullYear()) && (startCalender.getMonth() == selectedDate.getMonth()) && (startCalender.getDate() == selectedDate.getDate()));
            let newDate = new Date( startCalender.getFullYear(), startCalender.getMonth(), startCalender.getDate() );
        calenderRows.push(


              <button
                onClick={() => setSelected(newDate)}
                key={startCalender}
                type="button"
                className={classNames(
                  'py-1.5 hover:bg-gray-100 focus:z-10',
                  isCurrentMonth ? 'bg-white' : 'bg-gray-50',
                  (isSelected || isToday) && 'font-semibold',
                  isSelected && 'text-white',
                  !isSelected && isCurrentMonth && !isToday && 'text-gray-900',
                  !isSelected && !isCurrentMonth && !isToday && 'text-gray-400',
                  isToday && !isSelected && 'text-indigo-600',
                  dayIdx === 0 && 'rounded-tl-lg',
                  dayIdx === 6 && 'rounded-tr-lg',
                  dayIdx === days.length - 7 && 'rounded-bl-lg',
                  dayIdx === days.length - 1 && 'rounded-br-lg',
                )}
              >
                <time
                    
                  dateTime={startCalender}
                  className={classNames(
                    'mx-auto flex h-7 w-7 items-center justify-center rounded-full',
                    isSelected && isToday && 'bg-indigo-600',
                    isSelected && !isToday && 'bg-gray-900',
                  )}
                >
                  {startCalender.getDate()}
                </time>
              </button>

        
        );
    }
    
    return calenderRows;
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

  return (
       <div className="hidden w-full max-w-md flex-none border-l border-gray-100 px-8  md:block">
          <div className="flex items-center text-center text-gray-900">
            <button
              type="button"
              className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
              onClick={(event) => setMonth(month-1)}
            >
              <span className="sr-only">Previous month</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>
            <div className="flex-auto text-sm font-semibold">{monthNames[currentDate.getMonth()+1]} {currentDate.getFullYear()}</div>
            <button
              type="button"
              className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
              onClick={(event) => setMonth(month+1)}
            >
              <span className="sr-only">Next month</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true"  />
            </button>
          </div>
          <div className="mt-6 grid grid-cols-7 text-center text-xs leading-6 text-gray-500">
            <div>M</div>
            <div>T</div>
            <div>W</div>
            <div>T</div>
            <div>F</div>
            <div>S</div>
            <div>S</div>
          </div>

         <div className="isolate mt-2 grid grid-cols-7 gap-px rounded-lg bg-gray-200 text-sm shadow ring-1 ring-gray-200">
            {buildCalender(startCalender, currentDate)}
          </div>
          </div>
  )
}